(function WebHotelBookingForm($, HE)
{
	"use strict";


	var form = {
		name: 'HotelBooking',
	};

	$(document).ready(function documentReady()
	{
		HE.Form.registerForm(form);
	});

	form.load = function load($form)
	{
		// HE.Typeahead(
		// 	'.existing-traveler-search',
		// 	'/Travelers/search',
		// 	function selectTraveler(item, $self, typeahead) {
		// 		var $parent = $self.parents('.row.traveler');
		// 		typeahead.setHiddenValue(item.id);
		// 		$parent.find('input[id$="first_name"]').val(item.first_name);
		// 		$parent.find('input[id$="last_name"]').val(item.last_name);
		// 	}
		// );

		$('#hotelbooking-customer-country_id').on('change', function loadAgents()
		{
			var country_id = $(this).val();
			HE.Address.populateStates(country_id, $('#hotelbooking-customer-state_iso'));

			adjustLabels(country_id);

			// If not US or Canada, hide the state container
			if (country_id !== '183' && country_id !== '31') {
				$('#state-container').hide();
			} else {
				$('#state-container').show();
			}
		});
		
		$('#hotelbooking-payment-expiration_month, #hotelbooking-payment-expiration_year').on('change', toggleExpirationDateConfirm);
	};

	// if country is Canada, need to show different labels for State and Zip fields
	function adjustLabels(country_id)
	{
		var $state_label = $('#state_label'),
		    $zip_label   = $('#zip_label'),
		    state_txt    = 'State',
		    zip_txt      = 'Zip';

		// canada
		if (country_id === '31') {
			state_txt = $state_label.data('state-label-ca');
			zip_txt   = $zip_label.data('zip-label-ca');
		}

		replaceOnlyLabelTxt($state_label, state_txt);
		replaceOnlyLabelTxt($zip_label, zip_txt);
	}

	// don't replace elements within an element. Only replace its text. For example, labels contain <span class="required"></span>. don't want to replace those
	function replaceOnlyLabelTxt($el, text)
	{
		$el.contents().filter(
			function fil() {
				return this.nodeType === 3;
			}
		).first().replaceWith(" " + text);
	}

	function toggleExpirationDateConfirm()
	{
		// if hotelbooking-payment-expiration_month and hotelbooking-payment-expiration_year are not empty,
		// check if card expiration is less than 6 months from the check-out date
		// if so, show a warning message
		var $month                   = $('#hotelbooking-payment-expiration_month'),
		    $year                    = $('#hotelbooking-payment-expiration_year'),
		    $check_out_date          = $('#check-out-wrapper'),
		    check_out_date           = new Date($check_out_date.data('check_out')),
		    expiration_date          = null,
		    six_months_from_checkout = null;

		six_months_from_checkout = new Date(check_out_date);
		six_months_from_checkout.setMonth(check_out_date.getMonth() + 6);

		if ($month.val().trim() !== '' && $year.val().trim() !== '' && $('#hotelbooking-show_card_expiration_warning').val() === '1') {
			expiration_date = new Date($year.val(), $month.val() - 1, 28);

			// if the card expiration is less than 6 months from the check-out date, show the warning
			if (expiration_date < six_months_from_checkout) {
				form.confirm_before_submit = true;
				form.confirm_message = "As an industry standard, most hotels will not accept a credit card with an expiration date which falls within 6 months of the check-out date.  Click Yes to continue, knowing the reservation request may be rejected and an alternate credit card, with an expiration date of more than 6-months after the check-out will be needed to confirm the reservation.";
			} else {
				form.confirm_before_submit = false;
				form.confirm_message = null;
			}
		} else {
			return;
		}
	}
}(jQuery, window.HE || {}));
